module.exports = __webpack_public_path__ + "img/7.672f5777.png";